import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderIndustriesServe() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@0.75': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.00': {
                        slidesPerView: 1,
                        spaceBetween: 0,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 10,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper row gy-5 mt-lg-0"
            >

                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Automative Parts.webp" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                           
                            <a to="blog-details.html" className="d-5 blog-title-link" style={{textAlign:"center", marginBlock:"-30px", marginTop:"6px"}}> Automative Parts</a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Heavy Machinery.webp" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                           
                            <a to="blog-details.html" className="d-5 blog-title-link" style={{textAlign:"center", marginBlock:"-30px", marginTop:"6px"}}> Heavy Machinery</a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Pharmaceuticals.webp" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                           
                            <a to="blog-details.html" className="d-5 blog-title-link" style={{textAlign:"center", marginBlock:"-30px", marginTop:"6px"}}> Pharmaceuticals</a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Telecommunication.webp" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                           
                            <a to="blog-details.html" className="d-5 blog-title-link" style={{textAlign:"center", marginBlock:"-30px", marginTop:"6px"}}> Telecommunication</a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Mobile and Accessories.webp" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                           
                            <a to="blog-details.html" className="d-5 blog-title-link" style={{textAlign:"center", marginBlock:"-30px", marginTop:"6px"}}> Mobile and Accessories</a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Electricals and Electronics.webp" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                           
                            <a to="blog-details.html" className="d-5 blog-title-link" style={{textAlign:"center", marginBlock:"-30px", marginTop:"6px"}}> Electricals and Electronics</a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Garments.webp" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                           
                            <a to="blog-details.html" className="d-5 blog-title-link" style={{textAlign:"center", marginBlock:"-30px", marginTop:"6px"}}> Garments</a>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="swiper-slide swiper-slide-active" role="group" aria-label="1 / 4" style={{ width: 356, marginRight: 24 }} data-swiper-slide-index={0}>
                        <div className="blog-single-item-1">
                            <div className="img-block">
                                <img src="assets/img/Fast Moving Consumer Goods.webp" alt="blog-img-1" width={374} height={292} className="img-fluid w-100" />
                            </div>
                           
                            <a to="blog-details.html" className="d-5 blog-title-link" style={{textAlign:"center", marginBlock:"-30px", marginTop:"6px"}}> Fast Moving Consumer Goods</a>
                        </div>
                    </div>
                </SwiperSlide>
                

               




            </Swiper>
        </>
    );
}
